// @flow
import React, { Component } from 'react'
import Select from 'react-select'
import { connect } from 'react-redux'
import styles from './categoryTags.less'
import * as actions from '../actions'
import { getMarkets, getOpportunity } from '../selectors'

class MarketsSelect extends Component {
  props: {
    // action creators
    fetchMarketsIfNeeded: Function,
    putMarket: Function,
    // from state
    options: Array<Object>,
    value: ?{
      name: string,
      id: number,
    },
    isFetching: boolean,
    id: number,
    disabled: boolean,
    isPuttingMarket: boolean,
    putMarketError: Object,
  }
  state: {
    value: ?Object,
  }

  componentWillMount() {
    this.props.fetchMarketsIfNeeded()
  }

  componentWillReceiveProps({ putMarketError }) {
    if (putMarketError) {
      this.setState({ value: null })
    }
  }

  render() {
    const {
      id,
      isFetching,
      options,
      value,
      isPuttingMarket,
      putMarketError,
      putMarket,
    } = this.props
    let newVal = value
    if (this.state && this.state.value) {
      newVal = this.state.value
    }
    return (
      <div className={styles.select}>
        <Select
          name="market"
          isLoading={isFetching || isPuttingMarket}
          placeholder="Select a market for this org"
          options={options}
          value={newVal}
          labelKey="name"
          valueKey="id"
          onChange={value => this.setState({ value })}
          onBlur={() => {
            if (newVal) {
              putMarket({ orgId: id, marketId: newVal.id })
            }
          }}
        />
        {putMarketError
          ? <div className="bg-danger">
              Error: {putMarketError.response}
            </div>
          : null}
      </div>
    )
  }
}

const mapStateToProps = (state, { value }) => {
  const markets = getMarkets(state)
  const { isPuttingMarket, putMarketError } = getOpportunity(state)
  return {
    isFetching: markets.isFetching,
    isPuttingMarket,
    putMarketError,
    options: markets.items,
    value,
  }
}

export default connect(mapStateToProps, actions)(MarketsSelect)



// WEBPACK FOOTER //
// ./src/components/MarketsSelect.js